import * as types from './mutation-types'
import { fetchStatistiques } from '../../../api/statistiques'

const getInitialState = () => {
  return {
    stats: null,
    fetching: false
  }
}

const state = { ...getInitialState() }

const mutations = {
  [types.SET_STATS](state, stats) {
    state.stats = stats
  },
  [types.FETCH_STATS](state, fetching) {
    state.fetching = fetching
  }
}

const actions = {
  async updateStats({ commit }, params) {
    commit(types.FETCH_STATS, true)
    const stats = await fetchStatistiques(params)
    commit(types.SET_STATS, stats)
    commit(types.FETCH_STATS, false)
  }
}

const getters = {
  stats: state => state.stats,
  fetching: state => state.fetching
}

export default { state, mutations, actions, getters }
